import { render, staticRenderFns } from "./DietaryDiagnosticForm.vue?vue&type=template&id=706432b0&scoped=true&"
import script from "./DietaryDiagnosticForm.vue?vue&type=script&lang=js&"
export * from "./DietaryDiagnosticForm.vue?vue&type=script&lang=js&"
import style0 from "./DietaryDiagnosticForm.vue?vue&type=style&index=0&id=706432b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706432b0",
  null
  
)

export default component.exports